// removed by extract-text-webpack-plugin
module.exports = {"container":"src-page-components-memories----styles-module---container---9iwvY","header":"src-page-components-memories----styles-module---header---Wd1fV","options":"src-page-components-memories----styles-module---options---K0ctL","content":"src-page-components-memories----styles-module---content---3Sw9M","shown":"src-page-components-memories----styles-module---shown---LFYzi","listEnd":"src-page-components-memories----styles-module---listEnd---2VLKJ","progress":"src-page-components-memories----styles-module---progress---14OuS"};


//////////////////
// WEBPACK FOOTER
// ./src/page-components/memories/styles.module.css
// module id = 655
// module chunks = 73713890734725